package com.eladfinish.bible.contest.screens.randomVerse.ui.menu

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.ic_auto_renew
import com.eladfinish.bible.contest.ic_format_list_bulleted_type
import com.eladfinish.bible.contest.ic_settings_black
import com.eladfinish.bible.contest.new_verse
import com.eladfinish.bible.contest.random_verses_cocktail
import com.eladfinish.bible.contest.title_activity_settings
import com.eladfinish.bible.contest.ui.components.toolbar.SetToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarHeaderComponentConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarIcon
import com.eladfinish.bible.contest.ui.components.toolbar.model.ToolbarKind
import com.eladfinish.bible.contest.ui.menus.actions.RandomVerseToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.ToolbarActionEmitter
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.desc.desc
import kotlinx.collections.immutable.toImmutableList

enum class RandomVerseToolbarId {
    NEW_VERSE,
    SEVERAL_RANDOM_VERSES,
    SETTINGS,
}

@Composable
internal fun RandomVerseMenu(
    title: String,
    toolbarEmitter: ToolbarActionEmitter<RandomVerseToolbarAction>,
) {
    SetToolbarConfiguration(
        configuration = ToolbarConfiguration(
            kind = ToolbarKind.RandomVerse,
            title = ToolbarHeaderComponentConfig.Text(text = title),
            actions = listOfNotNull(
                ToolbarActionConfig.IconAction(
                    id = RandomVerseToolbarId.NEW_VERSE,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_auto_renew)
                    ),
                    menuText = SharedRes.strings.new_verse.desc(),
                    onClick = {
                        toolbarEmitter.emit(RandomVerseToolbarAction.NewVerse)
                    },
                ),
                ToolbarActionConfig.IconAction(
                    id = RandomVerseToolbarId.SEVERAL_RANDOM_VERSES,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_format_list_bulleted_type)
                    ),
                    menuText = SharedRes.strings.random_verses_cocktail.desc(),
                    onClick = {
                        toolbarEmitter.emit(RandomVerseToolbarAction.SeveralRandomVerses)
                    },
                ),
                ToolbarActionConfig.IconAction(
                    id = RandomVerseToolbarId.SETTINGS,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_settings_black)
                    ),
                    menuText = SharedRes.strings.title_activity_settings.desc(),
                    onClick = {
                        toolbarEmitter.emit(RandomVerseToolbarAction.Settings)
                    },
                ),
            ).toImmutableList(),
        )
    )
}
